import SelectBox, { Item, OtherSelectBoxProps } from '@/components/select/SelectBox';
import { MultiSelectProps, SingleSelectProps } from '@/components/select/useSelectBox';
import { InvoiceStatus } from '@/models/Invoice';

type InvoiceStatusSelectBoxProps<T extends Item> =
  | (SingleSelectProps<T> &
      OtherSelectBoxProps<T> & {
        multiple?: false;
      })
  | (MultiSelectProps<T> &
      OtherSelectBoxProps<T> & {
        multiple: true;
      });

interface InvoiceStatusItem {
  id: string;
  name: string;
}

const invoiceStatuses: { id: InvoiceStatus; name: string }[] = [
  { id: 'pending', name: 'Pending' },
  { id: 'succeeded', name: 'Paid' },
  { id: 'canceled', name: 'Canceled' },
];

const InvoiceStatusSelectBox = (props: InvoiceStatusSelectBoxProps<InvoiceStatusItem>) => {
  const { label = 'Status:', placeholder = 'Select status' } = props;

  const listInvoiceStatuses = (): Promise<InvoiceStatusItem[]> => {
    return Promise.resolve(invoiceStatuses);
  };

  return (
    <SelectBox<InvoiceStatusItem>
      {...props}
      name="invoiceStatus"
      label={label}
      placeholder={placeholder}
      deselectLabel="All statuses"
      queryFn={listInvoiceStatuses}
    />
  );
};

export default InvoiceStatusSelectBox;
